import { Icon } from '@chakra-ui/react';

const PCImageCarouselIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M23.63,9.87c-0.57-2.19-2.32-3.73-4.59-4.05c-0.03,0-0.07-0.03-0.1-0.04H5.43C5.01,5.89,4.57,5.95,4.17,6.1
		c-2.03,0.79-3.22,2.26-3.55,4.42c-0.04,0.24-0.04,0.48-0.04,0.72c0,4.09,0,8.18,0,12.26c0,2.74,1.88,4.96,4.58,5.42
		c0.24,0.04,0.5,0.06,0.74,0.06c3.62,0,6.35,0.01,9.97,0c0.57-0.25,0.73-1.17-0.05-1.43c-3.57,0-6.21-0.13-9.78-0.13
		c-1.95,0-3.53-1.33-3.87-3.25c-0.04-0.24-0.05-0.48-0.05-0.72c0-4.06,0-8.12,0-12.17c0-1.98,1.26-3.52,3.2-3.9
		c0.26-0.05,0.54-0.07,0.81-0.07c4.06,0,8.12,0,12.17,0.01c1.98,0,3.57,1.34,3.89,3.3c0.04,0.24,0.04,0.5,0.04,0.75
		c0,2,0,4.01,0,6.01c0,2.03,0,4.05,0,6.08c0,1.36-0.53,2.46-1.64,3.26c-0.67,0.49-1.44,0.71-2.27,0.71c-0.02,0-0.03,0-0.05,0
		c-0.62,0.45-0.65,1.26,0.01,1.55c0.06,0,0.11,0,0.17,0c2.66-0.01,4.97-2.08,5.29-4.73c0.01-0.04,0.03-0.08,0.04-0.12V10.63
		C23.74,10.38,23.69,10.12,23.63,9.87z"/>
			<path class="st0" d="M24.86,8.3c0.04,0.26,0.05,0.52,0.05,0.78c0,0.55,0,1.11,0,1.66c0,0,0.26,0.55,0.76,0.55
		c0.6,0,0.87-0.55,0.87-0.55V8.29c-0.06-0.27-0.11-0.54-0.17-0.8c-0.59-2.29-2.44-3.91-4.81-4.24c-0.04-0.01-0.07-0.03-0.11-0.04
		H7.29c-0.44,0.11-0.9,0.18-1.32,0.34C4.53,4.1,3.49,4.99,2.87,6.2C2.74,6.45,2.63,6.7,2.54,6.97h0C2.41,7.35,2.31,7.75,2.25,8.18
		C2.21,8.43,2.2,8.69,2.2,8.94v0c0,0,0,0,0,0C2.5,8.49,2.88,8.1,3.35,7.8C3.58,7.65,3.83,7.52,4.1,7.41
		c0.11-0.28,0.24-0.54,0.41-0.78c0.3-0.46,0.7-0.84,1.17-1.14C6.12,5.21,6.62,5.01,7.18,4.9c0.28-0.06,0.57-0.07,0.85-0.07
		c4.25,0,8.51,0,12.76,0.01C22.86,4.84,24.52,6.25,24.86,8.3z"/>
			<path class="st0" d="M24.91,12.69c0,0.9,0,1.79,0,2.69c0,2.12,0,4.25,0,6.37c0,0.88-0.21,1.65-0.65,2.32
		c-0.27,0.41-0.63,0.78-1.07,1.1c-0.02,0.02-0.05,0.04-0.07,0.05c-0.25,0.17-0.51,0.31-0.77,0.41c-0.1,0.27-0.24,0.53-0.4,0.76
		c-0.26,0.39-0.61,0.74-1.03,1.05c-0.03,0.02-0.06,0.04-0.09,0.06c-0.01,0.01-0.01,0.02-0.02,0.03h0.15c0.64,0,1.26-0.12,1.84-0.33
		c0.27-0.1,0.54-0.22,0.79-0.36v0c1.56-0.85,2.7-2.43,2.92-4.27c0.01-0.04,0.03-0.09,0.05-0.13v-9.79
		C26.51,11.87,25.03,11.83,24.91,12.69z"/>
			<path class="st0" d="M27.44,5.72c0,0.02,0,0.04,0.01,0.06c0.25,0.65,1.3,0.77,1.67,0c0.01-0.01,0-0.05,0-0.06
		c-0.03-0.27-0.11-0.54-0.17-0.8C28.34,2.63,26.5,1,24.13,0.68c-0.04-0.01-0.07-0.03-0.11-0.04H9.86c-0.44,0.11-0.9,0.18-1.32,0.34
		C7.1,1.53,6.07,2.42,5.44,3.63C5.32,3.87,5.21,4.13,5.12,4.4h0C4.98,4.78,4.89,5.18,4.82,5.61C4.79,5.86,4.78,6.12,4.78,6.37v0
		c0,0,0,0,0,0c0.29-0.45,0.68-0.84,1.14-1.14C6.15,5.08,6.4,4.94,6.68,4.84C6.78,4.56,6.92,4.3,7.08,4.06
		c0.3-0.46,0.7-0.84,1.17-1.14c0.43-0.28,0.94-0.48,1.49-0.59c0.28-0.06,0.57-0.07,0.85-0.07c4.25,0,8.51,0,12.76,0.01
		C25.44,2.27,27.1,3.67,27.44,5.72z"/>
			<path class="st0" d="M27.48,7.7c0,1.7,0,3.4,0,5.1c0,2.12,0,4.25,0,6.37c0,0.88-0.21,1.65-0.65,2.32c-0.27,0.41-0.63,0.78-1.07,1.1
		c-0.02,0.02-0.05,0.04-0.07,0.05c-0.25,0.17-0.51,0.31-0.77,0.41c-0.1,0.27-0.24,0.53-0.4,0.76c-0.26,0.39-0.61,0.74-1.03,1.05
		c-0.03,0.02-0.06,0.04-0.09,0.06c-0.01,0.01-0.01,0.02-0.02,0.03h0.15c0.64,0,1.26-0.12,1.84-0.33c0.27-0.1,0.54-0.22,0.79-0.36v0
		c1.56-0.85,2.7-2.43,2.92-4.27c0.01-0.04,0.03-0.09,0.05-0.13V7.7c0,0-0.14-0.62-0.82-0.62C27.58,7.08,27.48,7.7,27.48,7.7z"/>
			<path class="st0" d="M14.43,10.16c-1.18,0-2.15,0.97-2.15,2.15c0,1.19,0.96,2.16,2.13,2.16c1.21,0,2.18-0.97,2.18-2.17
		C16.59,11.13,15.6,10.16,14.43,10.16z M14.44,13.7c-0.76,0-1.38-0.62-1.38-1.38c0-0.76,0.62-1.38,1.38-1.38s1.38,0.62,1.38,1.38
		C15.82,13.08,15.2,13.7,14.44,13.7z"/>
			<g>
				<path class="st0" d="M14.38,19.39c-0.56,0.01-0.54,0.01-0.7-0.57c-0.27-1.01-0.91-1.66-1.89-1.85c-1-0.19-1.86,0.15-2.44,1.06
			c-0.22,0.34-0.39,0.45-0.8,0.36c-0.98-0.22-1.97,0.49-2.21,1.51c-0.01,0.05-0.02,0.1-0.03,0.15c-0.04,0.17-0.07,0.38-0.3,0.33
			c-0.2-0.05-0.14-0.26-0.13-0.41c0.14-1.23,1.38-2.2,2.64-2.04c0.23,0.03,0.36-0.03,0.5-0.22c0.7-0.96,1.64-1.37,2.77-1.19
			c1.13,0.19,1.87,0.91,2.24,2.03c0.09,0.27,0.19,0.39,0.49,0.4c1.37,0.03,2.49,1.13,2.64,2.57c0.14,1.41-0.73,2.75-2.03,3.1
			c-0.18,0.05-0.37,0.09-0.56,0.12c-0.16,0.02-0.34,0.02-0.37-0.18c-0.03-0.23,0.16-0.24,0.31-0.26c0.68-0.1,1.28-0.35,1.71-0.94
			c0.59-0.8,0.7-1.68,0.27-2.58C16.09,19.86,15.34,19.43,14.38,19.39z"/>
				<path class="st0" d="M14.48,25c-0.41,0-0.49-0.3-0.51-0.4c-0.03-0.17,0.03-0.28,0.07-0.34c0.11-0.15,0.29-0.18,0.41-0.19l0.03,0
			c0.73-0.11,1.21-0.37,1.55-0.84c0.54-0.74,0.63-1.53,0.25-2.33c-0.37-0.79-1.02-1.21-1.92-1.24c-0.65,0.01-0.75-0.07-0.92-0.7
			l-0.01-0.05c-0.25-0.94-0.82-1.5-1.7-1.67c-0.92-0.18-1.67,0.15-2.18,0.95c-0.24,0.38-0.5,0.59-1.06,0.46
			c-0.83-0.18-1.71,0.42-1.92,1.33c0,0.02-0.01,0.04-0.01,0.05c0,0.03-0.01,0.06-0.02,0.09l-0.01,0.04
			c-0.03,0.14-0.08,0.33-0.24,0.43c-0.07,0.04-0.18,0.08-0.34,0.04c-0.39-0.1-0.33-0.5-0.32-0.63c0-0.02,0-0.03,0.01-0.05
			c0.07-0.65,0.43-1.27,0.97-1.7c0.56-0.44,1.27-0.65,1.94-0.56c0.14,0.02,0.18,0,0.27-0.12c0.76-1.04,1.8-1.48,3.01-1.28
			c1.18,0.2,2.02,0.96,2.43,2.2c0.07,0.22,0.11,0.23,0.26,0.23c1.48,0.03,2.72,1.23,2.88,2.79c0.15,1.53-0.8,2.98-2.21,3.36
			c-0.19,0.05-0.39,0.09-0.58,0.12C14.58,24.99,14.53,25,14.48,25z M14.03,19.14c0.03,0.01,0.12,0.01,0.22,0.01
			c-0.13-0.05-0.22-0.12-0.29-0.22C13.99,19.03,14.01,19.11,14.03,19.14z M8.72,18.18c0.14,0.02,0.23-0.01,0.32-0.12
			C8.95,18.12,8.84,18.16,8.72,18.18z"/>
			</g>
		</g>

	</Icon>
);

export default PCImageCarouselIcon;
